const RAIL_SECTION_SELECTOR = "[data-rail-section]";

const focusRail = (root: ParentNode = document): boolean => {
	const target = root.querySelector<HTMLElement>(RAIL_SECTION_SELECTOR);
	if (!target) {
		return false;
	}
	target.focus();
	return true;
};

export default focusRail;
